import React from 'react';
import {
  Box,
  Heading,
  Text,
  Container,
  Image,
  Divider,
  Flex,
} from '@chakra-ui/react';
import './article-read.css';

const ArticleReadPage = ({ article }) => {
  if (!article) {
    return (
      <Flex direction="column" minH="60vh" justify="center" align="center" px={4} textAlign="center">
        <Heading size="lg" mb={2}>Article not found</Heading>
        <Text fontSize="md" color="gray.500" maxW="600px">
          Sorry, we couldn’t find the article you’re looking for. It may have been removed, or the link could be incorrect.
        </Text>
      </Flex>
    );
  }

  return (
    <Container flex="1" maxW="container.lg" p={4}>
      <Heading mb={2}>{article.title}</Heading>
      <Text fontSize="sm" color="gray.500">
        {article.category.charAt(0).toUpperCase() + article.category.slice(1)}
        {article.published_at && ` • ${new Date(article.published_at).toLocaleDateString()}`}
      </Text>
      {article.image_url && (
        <Image
          src={article.image_url}
          alt={article.title}
          mt={4}
          borderRadius="md"
          height="300px"
          width="100%"
          objectFit="cover"
          objectPosition="center center"
          onError={(e) => e.currentTarget.style.display = 'none'}
        />
      )}
      <Divider my={6} />
      <Box
        className="article-content"
        dangerouslySetInnerHTML={{ __html: article.content }}
      />
    </Container>
  );
};

export default ArticleReadPage;
